import React from "react";
import FaqComponent from "./faq.component";

const FaqContainer = () => {
  return <FaqComponent />;
};

export default FaqContainer;
